import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RolPlataforma } from '../../core/models/novedades.models';
import { RoleContextService } from '../../core/services/role-context.service';
import { AccessibilityToolbar } from '../../shared/components/accessibility-toolbar/accessibility-toolbar';
import { BreadcrumbItem, Breadcrumbs } from '../../shared/components/breadcrumbs/breadcrumbs';
import { HeaderNotificationBell } from '../../shared/components/header-notification-bell/header-notification-bell';
import { UserSessionSummary } from '../../shared/components/user-session-summary/user-session-summary';
import { SidebarMenu } from '../../shared/sidebar-menu/sidebar-menu';
import { PrincipalDashboardPanel } from './components/principal-dashboard-panel/principal-dashboard-panel';

@Component({
  selector: 'app-principal',
  imports: [
    CommonModule,
    FormsModule,
    SidebarMenu,
    PrincipalDashboardPanel,
    HeaderNotificationBell,
    AccessibilityToolbar,
    Breadcrumbs,
    UserSessionSummary,
  ],
  templateUrl: './principal.html',
  styleUrl: './principal.css',
})
export class Principal implements OnInit {
  readonly breadcrumbs: BreadcrumbItem[] = [{ label: 'Inicio' }];
  rolSeleccionado: RolPlataforma = 'administrador_anid';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly roleContext: RoleContextService
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.rolSeleccionado = this.roleContext.resolveRole(params, this.rolSeleccionado);
    });
  }
}
